<template>
    <div class="park" >
        <div class="mask" @click="hiddenList($event)" v-show="ishowProject || isShow"></div>
        <div class="overview">
            <div class="title">
                <div class="top">
                    {{viewName}}
                    <!-- <img src="../../assets/img/w.png" alt="" v-show="$store.state.currentPage != 0" @click="showproject" ref="pro"> -->
                </div>
                <!-- <transition name="el-zoom-in-top"> -->
                    <el-collapse-transition>
                    <div class="project" v-if="ishowProject">
                        <ProjectShow />
                    </div>
                    </el-collapse-transition>
                <!-- </transition> -->
                <div class="gateway">
                    网关在线: <span>2</span>/2
                </div>
            </div>
            <div class="siteTab" @click="showList()" ref="listh">
                切换站点
            </div>
        </div>
        <div class="sateGo" v-show=" $store.state.currentPage == 1">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>变配电站</p>
                    <p>2</p>
                </div>
                <div class="site">
                    <p>光伏电站</p>
                    <p>1</p>
                </div>
                <div class="site">
                    <p>储能集装箱</p>
                    <p>1</p>
                </div>
            </div>
        </div>
        <div class="sateGo" v-show=" $store.state.currentPage == 2">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>日均负荷率</p>
                    <p>{{loader}}<span>%</span></p>
                </div>
                <div class="site">
                    <p>变配电站数量</p>
                    <p>2</p>
                </div>
                <div class="site">
                    <p>变压器数量</p>
                    <p>1</p>
                </div>
            </div>
        </div>
        <div class="sateGo" v-show=" $store.state.currentPage == 3">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>日均负荷率</p>
                    <p>{{loader}}<span> %</span></p>
                </div>
                <div class="site">
                    <p>光伏电站</p>
                    <p>1</p>
                </div>
                <div class="site">
                    <p>储能集装箱</p>
                    <p>1</p>
                </div>
            </div>
        </div>
        <div class="sateGo" v-show="site.areaType == 1 && $store.state.currentPage == 0">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>平均负载率</p>
                    <p>{{arealoader}}<span> %</span></p>
                </div>
                <div class="site">
                    <p>装机容量</p>
                    <p>800<span> kVA</span></p>
                </div>
                <div class="site">
                    <p>电压等级</p>
                    <p>10/0.4<span> kV</span></p>
                </div>
            </div>
        </div>

        <div class="sateGo" v-show="site.areaType == 2 && $store.state.currentPage == 0">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>今日发电</p>
                    <p>{{equivalent.todayPowerSend}}<span> kWh</span></p>
                </div>
                <div class="site">
                    <p>等效小时</p>
                    <p>{{equivalent.equivalent.toFixed(2)}}<span> h</span></p>
                </div>
                <div class="site">
                    <p>装机容量</p>
                    <p>120<span> kWp</span></p>
                </div>
            </div>
        </div>

        <div class="sateGo" v-show="site.areaType == 3 && $store.state.currentPage == 0">
            <div class="safeDay">
                已安全运行 <span>{{projectTime}}</span> 天
            </div>
            <div class="sites">
                <div class="site">
                    <p>今日充电</p>
                    <p>{{equivalent.todayPowerIn}}<span> kWh</span></p>
                </div>
                <div class="site">
                    <p>今日放电</p>
                    <p>{{equivalent.todayPowerOut}}<span> kWh</span></p>
                </div>
                <div class="site">
                    <p>系统状态</p>
                    <p>正常</p>
                </div>
            </div>
        </div>

        <div class="list" v-show="isShow" >
            <SelectList :selectList="selectList" @tabTitle="tabTitle" keyk="areaId" keyval="areaName"/>
        </div>
    </div>
</template>

<script>
import {GetAllAreas} from '../../components/Request'
const SelectList = () => import('../../components/title/selectList.vue')
const ProjectShow = () => import('./ProjectShow.vue')
export default {
    data(){
        return{
            isShow:false,
            selectList:[],
            site:{},
            ishowProject:false,
            projectTime:'',
            loader:'',
            loaders:[]
        }
    },
    components:{
        SelectList,ProjectShow
    },
    computed:{
        csite(){
            let areaId = this.$store.state.siteId
            let site = this.selectList.find(item =>item.areaId == areaId)

            return site
        },
        viewName(){
            if(this.$store.state.currentPage == 0){
                return this.site.areaName 
            }else{
                return '园区总览'
            }
        },
        equivalent(){
            let weather = this.$store.state.Cang.weather
            let hour = new Date().getHours()
            let month = new Date().getMonth() + 1
            let year = new Date().getFullYear()
            let day = new Date().getDate()

            let obj = {
                    equivalent:0 ,        // 等效
                    todayPowerOut:0,      // 放电量
                    todayPowerIn:160,     // 充电量
                    todayPowerSend:160,     // 放电量
                }
            
            
            if(weather.indexOf('阴') != -1 || weather.indexOf('云') != -1 || weather.indexOf('雨') != -1){
                // 等效小时
                obj.equivalent = (4.5  * ((hour - 6) / 12 ))>4.5?4.5:(4.5  * ((hour - 6) / 12 ))

                // 计算发电量
                let seriesData = [0, 0, 0, 0, 0, 0, 3, 8, 17, 29, 47, 55, 57, 57, 54, 46, 38, 15, 7, 3, 0, 0, 0, 0, 0 ]
                obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))

            }else{
                obj.equivalent = (8 * ((hour - 6) / 12 )) > 8 ? 8 : (8 * ((hour - 6) / 12 ))

                // 计算发电量
                let seriesData = [0, 0, 0, 0, 0, 0, 7, 10, 31, 60, 90, 110,  117, 114,  109, 91, 61, 31, 11, 9, 0, 0, 0, 0, 0 ]
                obj.todayPowerSend = eval(seriesData.splice(0,hour + 1).join("+"))
            }

            let timeC = new Date().getTime()
            let timeA = new Date(`${year}-${month}-${day} 20:00:00`).getTime()
            let timeB = new Date(`${year}-${month}-${day} 17:00:00`).getTime()

            // 8点到10点放电电量 
            if(hour >= 20 && hour<= 22){
                let timeP = (timeC - timeA) / 1000 / 7200 * 160
                obj.todayPowerOut = timeP.toFixed(2)
            }else{
                obj.todayPowerOut = 0
            }

            // 0点到4点充电电量
            if(hour >= 0 && hour<= 4){
                let timeP = (timeC - timeB) / 1000 / 3600 * 400 * 160
                obj.todayPowerIn = timeP.toFixed(2)
            }else{
                obj.todayPowerIn = 160
            }

            return obj
        },
        arealoader(){
            let that = this
            let loader = 0
            if(this.site.areaId && this.loaders.length >0){
                this.loaders.forEach(item =>{
                    if(item.areaId == that.site.areaId){
                        loader = item.LoadPer
                    }
                })
                
            }
            console.log(loader);
            return loader.toFixed(2)
        }
    },
    watch:{
        csite(site){
            this.site = site 
            localStorage.setItem('currentSite',JSON.stringify(site))
        }
    },
    mounted(){
        this.getAllArea()
        this.getProjectTime()
        this.getDayLoad()
    },
    methods:{
        showList(){
            this.isShow = !this.isShow
            this.ishowProject = false
        },
        showproject(){
            this.ishowProject = !this.ishowProject
            this.isShow = false
        },
        tabTitle(site){
            this.isShow = false

            let localSite = localStorage.setItem('currentSite',JSON.stringify(site))

            this.site = site 
            // console.log(this.site);
            switch(site.areaType){
                case 1:
                    this.$router.push(`/site/${site.areaId}`)
                    break;
                case 2:
                    this.$router.push(`/pv/${site.areaId}`)
                    break;
                case 3:
                    this.$router.push(`/container/${site.areaId}`)
                    break;
            }
        },
        async getAllArea(){
            let that = this
            let res = await GetAllAreas({projectId:that.$store.state.projectId})
            this.selectList = res.data.data.areas 
            this.site = JSON.parse(localStorage.getItem('currentSite')) || {}

        },
        hiddenList(e){
            let area = this.$refs.listh
            let pro = this.$refs.pro

            if(area && !area.contains(e.target)){
                this.isShow = false
            }

            if(pro && !pro.contains(e.target)){
                this.ishowProject = false
            }
        },
        // 获取项目时间
        async getProjectTime(){
            let res = await this.$http.projectTime()
            this.projectTime = res.data.data.day
        },
        // 获取日均负荷率
        async getDayLoad(){
            let res = await this.$http.dayLoad({projectId:this.$store.state.projectId})
            console.log(res);
            this.loaders = res.data.data.influxData.load
            this.loader = res.data.data.influxData.load.find(item => item.projectId).LoadPer.toFixed(2)

        }
    }
}
</script>

<style lang="less" scoped>
    .park{
        width: 20vw;
        height: 22.2vh;
        position: fixed;
        top: 7.4vh;
        left: 2vw;
        border-top: 4rem solid rgba(13,148,255, 0.3);
        background: linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

        .mask{
            width: 100vw;
            height: 100vh;
            position: fixed;
            left: 0;
            top: 0;
            z-index: -1;
        }
        .overview{
            width: 100%;
            height: 7.3vh;
            padding: 7rem 0 4rem;
            border-bottom: 1px dashed #0D94FF;
            position: relative;

            .title{
                position: absolute;
                left: 0;
                top: 7rem;
                width: 16.8vw;
                height:6.2vh ;
                background: url(../../assets/img/园区总览.png);
                background-size: 100% 100%;
                padding-left: 1.5vw;

                .top{
                    font-size: 3.3vh;
                    height: 4.5vh;
                    font-family: YouSheBiaoTiHei;
                    font-weight: 400;
                    color: #FFFFFF;
                    cursor: pointer;
                    img{
                        width: 20rem;
                        right: 20rem;
                        transform: scale(1.3);
                        margin-left: -0.5vw;
                    }
                }
                .gateway{
                    margin-top: -5rem;
                    font-size: 1.45vh;
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    span:nth-child(1){
                        padding-left: 2rem; 
                        color: rgba(63,235,167, 0.7);
                    }
                }

                .project{
                    width:20vw ;
                    position: absolute;
                    left: 0;
                    top: 4.2vh;
                }
                
            }

            .siteTab{
                position: absolute;
                right: 0;
                top: 11rem;
                width:5vw ;
                height: 3.5vh;
                background: url(../../assets/img/切换站点.png);
                background-size: 100% 100%;
                font-size: 16rem;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: rgba(230,243,253, 0.7);
                padding:2rem 0 0 1.5vw;
                cursor: pointer;
            }
        }

        .sateGo{
            .safeDay{   
                padding: 2.5vh 0;
                font-family: SourceHanSansCN-Regular;
                text-align: center;
                font-size: 16rem;
                color: #fff;
                text-shadow: 
                    0 0 1vh  rgba(13,148,255, 0.9),
                    0 0 2vh  rgba(13,148,255, 0.9),
                    0 0 3vh  rgba(13,148,255, 0.9); 
                span{
                    font-size: 30rem;
                    font-family: zcoolqingkehuangyouti;
                }
            }

            .sites{
                padding: 0 1vw;
                display: flex;
                justify-content: space-between;
                .site{
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    text-align: center;
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        color: #00DEFF;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
            }
        }
        .list{
            position: absolute;
            height: 17.2vh;
            width: 100%;
            top:4.6vh ;
            left: 0;
        }
    }
</style>